// extracted by mini-css-extract-plugin
export default {"cls1":"b0aIlUu8XSJ0GzAs2xnS","cls2":"oBc6GeGKnhUPU846cnm1 b0aIlUu8XSJ0GzAs2xnS","isTabletDown":"PyZoUDBITS52j8E6b5MH"};